import { UiState } from 'constants/ui';
import { stateName } from './constants';

const localState = state => state[stateName];

export const getBanners = state => localState(state).banners;
export const getBannersUiState = state => localState(state).uiState;
export const getModalDisplayStatus = state => {
  var _banners$onboardingMo;

  const {
    banners,
    uiState
  } = localState(state) || {};
  if (uiState === UiState.Pending) return 'pending';
  if (banners !== null && banners !== void 0 && banners.categoryIntentBanner) return 'shown';
  if (banners !== null && banners !== void 0 && banners.onboardingModal && !(banners !== null && banners !== void 0 && (_banners$onboardingMo = banners.onboardingModal) !== null && _banners$onboardingMo !== void 0 && _banners$onboardingMo.isClosed)) return 'shown';
  return 'not shown';
};